import CommentForm from "./CommentForm"
import { getCommentProductsById } from "@/core/lib/api/main/main-shop-product"
import CommentList from "./CommnetList"

export interface CommentItem {
  id: number
  author_name: string
  created_at: string
  created_at_jalali?: string
  subject?: string
  content: string
}

interface ProductCommentsProps {
  productId: number
}

export default async function ProductComments({
  productId,
}: ProductCommentsProps) {
  const comments = await getCommentProductsById(productId);

  return (
    <div className="flex flex-col gap-8 p-4"
      style={{
        borderImageSlice: '4 4 4 4',
        borderImageWidth: '4px 4px 4px 4px',
        borderImageOutset: '.5px .5px .5px .5px',
        borderImageRepeat: 'round round',
        borderImageSource: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB3SURBVHgB7dVBCoAgFEXR911JjcRVVSurXamj2on5wiCkWd9RnpkiF0FRCSEkZCKyWWsXPHjvhzy/o5JSGp1zR7V2y2una3BHtbBnuEMo0u51Ba8NFLFn3u7hF+wZNPD3KB8HKNLudUWMcYUi9nj6MxSxJy3+qBOdU0PNJhRu4gAAAABJRU5ErkJggg==)',
        borderStyle: 'solid',
        imageRendering: 'pixelated'
      }}>

      <CommentForm productId={productId} comments={comments} />

      {/* Comments list */}
      <CommentList comments={comments} />
    </div>
  )
}